import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import VersionInfo from '@gef-ui/material/components/VersionInfo';

import { toBeLogDateTime } from 'utils/apiDateTime';
import { joinString } from 'utils/string';

const Version = ({ screenId, screenName, sx }) => (
	<Box
		sx={{
			'[id=screen-info] p': {
				color: (theme) => theme.palette.grey[400],
			},
			'[id=version-info] p': {
				color: (theme) => theme.palette.grey[700],
			},
			...sx,
		}}
	>
		<VersionInfo
			screenName={joinString(' – ', [joinString(' - ', [screenId, screenName]), toBeLogDateTime(new Date())])}
			screenNameTestId="test-screenName"
			screenIdTestId="test-screenId"
			screenIdElementId="screen-info"
			versionElementId="version-info"
		/>
	</Box>
);

Version.propTypes = {
	screenId: PropTypes.string,
	screenName: PropTypes.string,
	sx: PropTypes.object,
};

export default Version;
